import React from 'react';

import styles from './tagsFormSuggestStyles';

import AddRemoveButton from 'buyside/components/presentation/AddRemoveButton/addRemoveButton';
import Button, { BUTTON_TYPES, BUTTON_SIZES } from 'buyside/components/presentation/Button/button';
import AlertStatic from 'buyside/components/presentation/AlertStatic/alertStatic';

import XMarkIcon from 'buyside/svgs/x_mark.svg';

class TagsFormSuggest extends React.Component {
  constructor() {
    super();
    this.state = {
      formOpen: false,
      submitted: false,
      name: '',
      description: ''
    };
    this.openForm = this.openForm.bind(this);
    this.closeForm = this.closeForm.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  openForm() {
    this.setState({ formOpen: true, name: '', description: '' });
    setTimeout(() =>
      document.getElementById('tags-form-suggest-box').scrollIntoView({ behavior: 'smooth' })
    );
  }

  closeForm() {
    this.setState({ formOpen: false });
  }

  handleChange(e, field) {
    this.setState({ [field]: e.target.value });
  }

  handleFormSubmit() {
    const { name, description } = this.state;
    this.props.suggestTag({ name, description });
    this.setState({ formOpen: false, submitted: true });
    setTimeout(() => this.setState({ submitted: false }), 5000);
  }

  render() {
    return (
      <div className={styles.tagsFormSuggest}>
        <AddRemoveButton type="add" text="Suggest a New Tag" onClick={this.openForm} />
        {this.state.formOpen && (
          <div id="tags-form-suggest-box" className={styles.tagsFormSuggestBox}>
            <div className={styles.tagsFormSuggestInfo}>
              <span>
                Include the suggested tag name along with a brief description (group, reason, etc).
              </span>
              <XMarkIcon className={styles.tagsFormSuggestClose} onClick={this.closeForm} />
            </div>
            <div>
              <label className={styles.tagsFormSuggestLabel}>
                Tag Name
                <input
                  id="name"
                  className={`form-control ${styles.tagNameInput}`}
                  value={this.state.name}
                  onChange={e => this.handleChange(e, 'name')}
                />
              </label>
            </div>
            <div>
              <label className={styles.tagsFormSuggestLabel}>
                Description
                <input
                  id="description"
                  className={`form-control ${styles.tagDescriptionInput}`}
                  value={this.state.description}
                  onChange={e => this.handleChange(e, 'description')}
                />
              </label>
            </div>
            <div className={styles.tagsFormSuggestButtons}>
              <Button
                text="Suggest Tag"
                onClick={this.handleFormSubmit}
                size={BUTTON_SIZES.SMALL}
                type={BUTTON_TYPES.PRIMARY}
                buttonType={BUTTON_TYPES.BUTTON}
              />
              <Button
                text="Cancel"
                onClick={this.closeForm}
                size={BUTTON_SIZES.SMALL}
                type={BUTTON_TYPES.SECONDARY}
                buttonType={BUTTON_TYPES.BUTTON}
              />
            </div>
          </div>
        )}
        {this.state.submitted && (
          <div className={styles.tagsFormSuggestThanks}>
            <AlertStatic>Thanks for your suggestion! We'll review it soon.</AlertStatic>
          </div>
        )}
      </div>
    );
  }
}

export default TagsFormSuggest;
